import React from 'react'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import DropdownBar from '@ifca-root/react-component/src/components/SpecialBar/DropdownBar'
import { SearchBar } from '@ifca-root/react-component/src/components/SpecialBar/SearchBar'
import {
  useGetUsersByAccountAndSoftwareQuery,
  useGetCategoryChangeStatusListingQuery,
} from 'generated/graphql'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import { useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { ChangeAssetCategoryEntryList } from './ChangeAssetCategoryList/ChangeAssetCategoryEntryList'
import { ChangeAssetCategoryPostingList } from './ChangeAssetCategoryList/ChangeAssetCategoryPostingList'

export const ChangeAssetCategoryMain = (props: any) => {
  let history = useHistory()
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  /* -------------------------------------------- */
  /*                   VARIABLES                  */
  /* -------------------------------------------- */
  const approvalStatusEnum = [
    { name: 'Draft', ID: 'ACTIVE' },
    { name: 'Submitted', ID: 'SUBMIT' },
    { name: 'Approved', ID: 'COMPLETED' },
    { name: 'Rejected', ID: 'REJECTED' },
    { name: 'All', ID: 'ALL' },
  ]

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */
  const [listStatus, setListStatus] = useState<string>(
    getSearch?.option ?? 'ACTIVE'
  )
  const [searchValue, setSearchValue] = useState<string>(getSearch?.name || '')

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */
  const {
    loading: CategoryChangeLoading,
    data: { getCategoryChangeStatusListing } = {
      getCategoryChangeStatusListing: { Data: [], TotalLength: 0 },
    },
    fetchMore,
    refetch,
  } = useGetCategoryChangeStatusListingQuery({
    variables: {
      CompanyID,
      StatusArr:
        listStatus === 'ALL'
          ? ['ACTIVE', 'SUBMIT', 'COMPLETED', 'REJECTED']
          : [listStatus],
      skip: 0,
      take: 30,
      searchValue: searchValue || undefined,
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  })

  const {
    loading: UserLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({ fetchPolicy: 'network-only' })

  /* -------------------------------------------- */
  /*                    SEARCH                    */
  /* -------------------------------------------- */
  const { handleSearch, setOriginalListing } = useFuseSearch()

  const handleSearchChange = (value: string) => {
    setSearchValue(value)
    refetch({
      CompanyID,
      StatusArr:
        listStatus === 'ALL'
          ? ['ACTIVE', 'SUBMIT', 'COMPLETED', 'REJECTED']
          : [listStatus],
      skip: 0,
      take: 30,
      searchValue: value || undefined,
    })
  }

  return (
    <>
      {(UserLoading || CategoryChangeLoading) && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/fixed-assets/${CompanyID}/assets-change`)
          localStorage.removeItem(`searchFilter`)
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Change Assets Category', current: true },
        ]}
      />

      <div className="search-filter with-dropdown-filter">
        <SearchBar
          borderRadius="4px"
          onChangeAction={e => handleSearchChange(e.target.value)}
          defaultValue={getSearch?.name ? getSearch?.name : ''}
          onCloseAction={() => {
            setSearchValue('')
            handleSearchChange('')
            handleSearch('', [])
            setOriginalListing([])
          }}
          isDefaultValue={!!getSearch?.name}
        />

        <DropdownBar
          options={approvalStatusEnum}
          setOptionID={setListStatus}
          borderRadius="4px"
          defaultOption={approvalStatusEnum
            ?.map(opt => opt?.ID)
            .indexOf(listStatus ?? 'ACTIVE')}
          searchFilter={getSearch}
        />
      </div>

      {(listStatus === 'ACTIVE' ||
        listStatus === 'COMPLETED' ||
        listStatus === 'REJECTED' ||
        listStatus === 'ALL') && (
        <ChangeAssetCategoryEntryList
          filteredList={getCategoryChangeStatusListing?.Data || []}
          listLoading={CategoryChangeLoading}
          listStatus={listStatus}
          userList={getUsersByAccountAndSoftware}
          setOriginalListing={setOriginalListing}
          fetchMore={fetchMore}
          refetch={refetch}
        />
      )}

      {listStatus === 'SUBMIT' && (
        <ChangeAssetCategoryPostingList
          filteredList={getCategoryChangeStatusListing?.Data || []}
          listLoading={CategoryChangeLoading}
          listStatus={listStatus}
          userList={getUsersByAccountAndSoftware}
          setOriginalListing={setOriginalListing}
          fetchMore={fetchMore}
          refetch={refetch}
        />
      )}
    </>
  )
}
